import React, { InputHTMLAttributes } from 'react'

import { isNil } from 'lodash'

import * as S from './styles'

type RadioValue = boolean | string | ReadonlyArray<string> | number

export type Props = {
  onCheck?: (value?: any) => void
  label?: string
  labelColor?: 'white' | 'black'
  labelFor?: string
  value?: RadioValue
  dataTestId?: number | string
  customValue?: any
  type?: 'radio' | 'checkbox'
} & InputHTMLAttributes<HTMLInputElement>

const Chip = ({
  label,
  onCheck,
  value,
  customValue,
  type = 'radio',
  ...props
}: Props) => {
  const onChange = () => {
    !!onCheck && !props.disabled && !!value && onCheck(value)
    !!onCheck && !props.disabled && !isNil(customValue) && onCheck(customValue)
  }

  return (
    <S.InputContainer onClick={onChange}>
      <S.Input
        value={value}
        name={props.name}
        onChange={onChange}
        type={type}
        role={type}
        {...props}
      />
      <S.InputLabel
        isChecked={!!(props.checked || props.defaultChecked)}
        htmlFor={label}
        disabled={props.disabled}
        data-testid={`chip-${props.dataTestId}`}
      >
        {label}
      </S.InputLabel>
    </S.InputContainer>
  )
}

export default Chip
